import DashboardCard, { EmptyState } from './DashboardCard';
import CardGrid from './CardGrid';
import { CARD_FILL_MIN_WIDTH, cardDateColumn, yesOrBlank, type CardColumn } from './cardColumns';
import type { DashboardAdmittedResident } from '../../types/dashboard';
import { useGlobalStore } from '../../stores/globalStore';
import { useDashboardNav } from './useDashboardNav';

const columns: CardColumn<DashboardAdmittedResident>[] = [
  { dataField: 'fullName', caption: 'Name', sizing: 'fill' },
  { dataField: 'dietOrder', caption: 'Diet Order', sizing: 'fill', minWidth: CARD_FILL_MIN_WIDTH },
  cardDateColumn<DashboardAdmittedResident>('admitDate', 'Admit/Readmit Date', { sortOrder: 'desc' }),
  { dataField: 'readmit', caption: 'Readmit', customizeText: yesOrBlank },
];

interface Props {
  data: DashboardAdmittedResident[];
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
}

export default function AdmittedResidentsCard({ data, ...dragProps }: Props) {
  const { rowLinkProps } = useDashboardNav();
  const plural = useGlobalStore((s) => s.residentPluralLabel);
  const title = `Admitted ${plural}`;
  return (
    <DashboardCard severity="success" icon="bi-person-plus" title={title} count={data.length} {...dragProps}>
      {data.length === 0 ? (
        <EmptyState message={`No admitted ${plural.toLowerCase()}`} />
      ) : (
        <CardGrid<DashboardAdmittedResident>
          {...rowLinkProps<DashboardAdmittedResident>((r) => r.pKey_Patient)}
          ariaLabel={title}
          dataSource={data}
          columns={columns}
          keyExpr="pKey_Patient"
        />
      )}
    </DashboardCard>
  );
}
